import { VerticalAlignTopOutlined } from '@ant-design/icons';
import { BackTop } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ToolsButton } from '@/presentation/layouts/tools/button';
import style from './index.module.scss';

export const BackToTop = () => {
  const { t } = useTranslation();
  const [hover, setHover] = useState(false);

  const content = <div
    onMouseEnter={() => setHover(true)}
    onMouseLeave={() => setHover(false)}
  >
    <ToolsButton>
      {hover ? t('回到顶部') : <VerticalAlignTopOutlined style={{ fontSize: '20px' }}/>}
    </ToolsButton>
  </div>;

  return <div className={style.backTop}>
    <BackTop children={content} />
  </div>;
};
